module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAJCAYAAADgkQYQAAAAsklEQVQoU13PMQrCMBTG8e8TOoSuQouDm9fR0UlBEA/QE+QEXUNBEXRyVPA0bg7SgmvJUPBJipFHs+b3kv+jc+5O8l3X9cZa+8HvWGtHeZ4fRWTMsiyNMeZG8hWhAhPv/ZxhUEOSWxHZi0gPiqLwPdIQwAzAI4Jw90fhiyzLTgAWAK5N06xjY490Q5Iky67rLrqRw8jQMFyGzrkDgKluGDQ+WVXVrm3bc3ghLqGXSdN09QUQ/3lMK6ZosgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/images/audio/close1.png
// module id = HJik
// module chunks = 1